<template>
  <nav class="bg-gray-800 p-4 fixed w-full top-0 z-10" ref="navBar">
    <div class="container mx-auto flex justify-between items-center">
      <div class="text-white text-lg font-bold">
        Stawski Maxime
      </div>
      <!-- Menu principal visible sur les écrans md et plus -->
      <div class="hidden md:flex space-x-4">
        <a href="#Présentation" class="text-gray-300 hover:text-white">Présentation</a>
        <a href="#Mon parcours" class="text-gray-300 hover:text-white">Mon Parcours</a>
        <a href="#Mes projets" class="text-gray-300 hover:text-white">Mes Projets</a>
        <a href="#Mes compétences" class="text-gray-300 hover:text-white">Mes Compétences</a>
        <a href="#Contact" class="text-gray-300 hover:text-white">Contact</a>
      </div>
      <!-- Bouton burger pour mobile -->
      
      <div class="md:hidden">
        <button
          @click="toggleMenu"
          class="text-gray-300 hover:text-white focus:outline-none"
        >
          <svg v-show="!isMenuOpen"
            class="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 12h16m-7 6h7"
            ></path>
          </svg>

          <svg v-show="isMenuOpen" class="w-6 h-6" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.32129 2.32363C2.72582 1.9191 3.38168 1.9191 3.78621 2.32363L25.6966 24.234C26.1011 24.6385 26.1011 25.2944 25.6966 25.6989C25.2921 26.1035 24.6362 26.1035 24.2317 25.6989L2.32129 3.78854C1.91676 3.38402 1.91676 2.72815 2.32129 2.32363Z" fill="#FFFFFF"></path><path d="M25.6787 2.30339C25.2742 1.89887 24.6183 1.89887 24.2138 2.30339L2.30339 24.2138C1.89887 24.6183 1.89887 25.2742 2.30339 25.6787C2.70792 26.0832 3.36379 26.0832 3.76831 25.6787L25.6787 3.76831C26.0832 3.36379 26.0832 2.70792 25.6787 2.30339Z" fill="#FFFFFF"></path></svg>

        </button>
      </div>


    </div>
    <!-- Menu mobile caché par défaut -->
    <div
      v-show="isMenuOpen"
      class="md:hidden flex flex-col text-right space-y-2 mt-4"
    >
      <a @click="closeMenu" href="#Présentation" class="text-gray-300 hover:text-white">Présentation</a>
      <a @click="closeMenu" href="#Mon parcours" class="text-gray-300 hover:text-white">Mon Parcours</a>
      <a @click="closeMenu" href="#Mes projets" class="text-gray-300 hover:text-white">Mes Projets</a>
      <a @click="closeMenu" href="#Mes compétences" class="text-gray-300 hover:text-white">Mes Compétences</a>
      <a @click="closeMenu" href="#Contact" class="text-gray-300 hover:text-white">Contact</a>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'ComponentNav',
  data() {
    return {
      isMenuOpen: false, 
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    closeMenu() {
      this.isMenuOpen = false;
    },
    handleClickOutside(event) {
      const navBar = this.$refs.navBar;
      if (navBar && !navBar.contains(event.target)) {
        this.closeMenu();
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>

<style scoped>
</style>
